(() => {
  if (customElements.get('hdp-ride-selector')) return;
  const key = 'hdp-selected-ride-v1';
  let sharedData, sharedCurrency;
  class RideSelector extends HTMLElement {
    async connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.fields = Object.fromEntries(['year','make','vehicle'].map(n => [n,this.querySelector(`[data-field="${n}"]`)]));
      this.status = this.querySelector('[data-status]');
      this.results = this.querySelector('[data-results]');
      try {
        sharedData ||= fetch(this.dataset.source).then(r => { if (!r.ok) throw Error('Unavailable'); return r.json(); }).then(d => {
          d.applications=d.applications.map(([p,v,years])=>({handle:d.products[p][0],title:d.products[p][1],make:d.vehicles[v][0],vehicle:d.vehicles[v][1],years}));
          return d;
        });
        this.data = await sharedData;
        if (!Array.isArray(this.data.applications)) throw Error('Invalid data');
        this.options('year', this.data.applications.flatMap(r=>r.years).sort((a,b)=>b-a), 'Select year');
        this.fields.year.addEventListener('change',()=>this.changeYear());
        this.fields.make.addEventListener('change',()=>this.changeMake());
        this.fields.vehicle.addEventListener('change',()=>this.showMatches());
        if(!this.dataset.product) {
          this.clearButton=document.createElement('button');this.clearButton.type='button';
          this.clearButton.className='hdp-ride__back';this.clearButton.textContent='Clear bike';
          this.clearButton.hidden=true;
          this.clearButton.addEventListener('click',()=>{try{localStorage.removeItem(key);localStorage.removeItem('hdp-garage-wheel-context-v1');window.dispatchEvent(new Event('hdp:ride-changed'));}catch(_){}this.fields.year.value='';this.changeYear();this.status.textContent='Select your ride, or browse all products below.';});
          this.querySelector('.hdp-ride__fields').after(this.clearButton);
        }
        this.status.textContent = 'Select your motorcycle to find matching parts.';
        try {
          const saved = JSON.parse(localStorage.getItem(key));
          if (saved && [...this.fields.year.options].some(o=>o.value===saved.year)) {
            this.fields.year.value=saved.year; this.changeYear();
            if ([...this.fields.make.options].some(o=>o.value===saved.make)) {
              this.fields.make.value=saved.make; this.changeMake();
              if ([...this.fields.vehicle.options].some(o=>o.value===saved.vehicle)) { this.fields.vehicle.value=saved.vehicle; this.showMatches(); }
            }
          }
        } catch (_) { /* Storage is optional. */ }
        this.collapseTables();
        window.dispatchEvent(new Event('hdp:finder-ready'));
        try {const saved=JSON.parse(localStorage.getItem(key));if(saved && this.fields.vehicle.value!==saved.vehicle){this.fields.year.value='';this.changeYear();this.status.textContent='Your saved bike is not covered by this finder yet. Contact our shop; fitment is not confirmed.';}}catch(_){}
      } catch (_) { this.status.textContent='Fitment information could not load. Please contact our shop; no fitment is confirmed.'; }
    }
    options(name, values, placeholder) {
      const select=this.fields[name]; select.replaceChildren(new Option(placeholder,''));
      for(const v of [...new Set(values)]) select.add(new Option(v,String(v)));
      select.disabled=values.length===0;
    }
    changeYear() {
      this.setFilteredView(false);
      const year=Number(this.fields.year.value);
      this.options('make',this.data.applications.filter(r=>r.years.includes(year)).map(r=>r.make).sort(),'Select make');
      this.options('vehicle',[],'Select make first'); this.results.replaceChildren();
      this.status.textContent='Select make, then the exact model / submodel.';
    }
    changeMake() {
      this.setFilteredView(false);
      const year=Number(this.fields.year.value),make=this.fields.make.value;
      this.options('vehicle',this.data.applications.filter(r=>r.years.includes(year)&&r.make===make).map(r=>r.vehicle).sort(),'Select model / submodel');
      this.results.replaceChildren(); this.status.textContent='Select the exact model / submodel.';
    }
    showMatches() {
      const ride=Object.fromEntries(Object.entries(this.fields).map(([n,e])=>[n,e.value]));
      this.results.replaceChildren(); if(!ride.vehicle) {this.setFilteredView(false);this.status.textContent='Select the exact model / submodel.';return;}
      this.setFilteredView(true);
      const matches=this.data.applications.filter(r=>r.years.includes(Number(ride.year))&&r.make===ride.make&&r.vehicle===ride.vehicle);
      try {localStorage.setItem(key,JSON.stringify(ride));} catch (_) {}
      window.dispatchEvent(new Event('hdp:ride-changed'));
      if(this.dataset.product) {
        const yes=matches.some(r=>r.handle===this.dataset.product);
        this.status.textContent=yes?'Listed for your selected ride in our catalog. Check product notes and modifications before ordering.':'Fitment is not confirmed for this product and ride. Contact our shop before ordering.';
        try {const context=JSON.parse(localStorage.getItem('hdp-garage-wheel-context-v1'));if(context?.wheelSetup==='modified' && context.year===ride.year && context.make===ride.make && context.vehicle===ride.vehicle)this.status.textContent='Your wheels are modified. Catalog applications do not confirm fitment; contact our shop before ordering.';}catch(_){}
      } else {
        const unique=[...new Map(matches.map(r=>[r.handle,r])).values()];
        this.showCategories(unique);
      }
    }
    showCategories(unique) {
      this.results.replaceChildren();
      this.status.textContent=`${unique.length} products have catalog applications for your ride. Choose a category.`;
      const assigned=new Set();
      for(const category of this.data.categories||[]) {
        const rows=unique.filter(r=>category.handles.includes(r.handle));
        if(!rows.length)continue;
        rows.forEach(r=>assigned.add(r.handle));this.categoryCard(category.title,category.image,rows,unique);
      }
      const other=unique.filter(r=>!assigned.has(r.handle));
      if(other.length)this.categoryCard('Other Parts',null,other,unique);
      if(unique.length)this.categoryCard('All Matching Parts',null,unique,unique);
    }
    setFilteredView(active) {
      if(this.dataset.product)return;
      const section=this.closest('.shopify-section'),main=this.closest('main');
      if(!section||!main)return;
      section.classList.remove('hdp-ride-active');main.classList.remove('hdp-ride-filtered');
      if(this.clearButton)this.clearButton.hidden=!active;
    }
    categoryCard(title,imageUrl,rows,all) {
      const li=document.createElement('li'),button=document.createElement('button');
      li.className='hdp-ride-card';button.type='button';button.className='hdp-ride-card__link hdp-ride-card__category';
      button.dataset.category=title;
      const media=document.createElement('div');media.className='hdp-ride-card__media';
      const image=document.createElement('img');image.alt=title;image.loading='lazy';image.width=640;image.height=640;
      const showImage=url=>{try{const u=new URL(url,location.origin);if(u.protocol!=='https:')return;u.searchParams.set('width','640');image.src=u.href;media.replaceChildren(image);}catch(_){}};
      media.textContent='View '+title;
      if(imageUrl)showImage(imageUrl);
      else fetch((window.Shopify?.routes?.root||'/')+'products/'+encodeURIComponent(rows[0].handle)+'.js').then(r=>r.ok?r.json():null).then(p=>{if(p?.featured_image&&li.isConnected)showImage(p.featured_image);}).catch(()=>{});
      image.addEventListener('error',()=>{media.textContent='View '+title;},{once:true});
      const body=document.createElement('div');body.className='hdp-ride-card__body';
      const heading=document.createElement('h3');heading.textContent=title;
      const count=document.createElement('p');count.textContent=rows.length+' matching '+(rows.length===1?'product':'products');
      const action=document.createElement('span');action.className='hdp-ride-card__action';action.textContent='Shop category →';
      body.append(heading,count,action);button.append(media,body);li.append(button);this.results.append(li);
      button.addEventListener('click',()=>this.showProducts(rows,title,all));
    }
    showProducts(rows,title,all) {
        this.results.replaceChildren();
        this.status.replaceChildren();
        const back=document.createElement('button');back.type='button';back.className='hdp-ride__back';back.textContent='← Back to categories';back.addEventListener('click',()=>this.showCategories(all));
        this.status.append(back,document.createTextNode(' '+title+' · '+rows.length+' matching products'));
        this.status.scrollIntoView({block:'start',behavior:'auto'});
        const cards=rows.map(r=>this.productCard(r));
        let cursor=0;
        const worker=async()=>{while(cursor<cards.length){const card=cards[cursor++];if(!card.li.isConnected)return;await this.loadCard(card);}};
        Promise.all(Array.from({length:Math.min(4,cards.length)},worker));
    }
    productCard(row) {
      const root=window.Shopify?.routes?.root||'/';
      const li=document.createElement('li'),link=document.createElement('a');
      li.className='hdp-ride-card';link.className='hdp-ride-card__link';
      link.href=root+'products/'+encodeURIComponent(row.handle);
      const media=document.createElement('div');media.className='hdp-ride-card__media';
      const placeholder=document.createElement('span');placeholder.textContent='Loading product photo…';media.append(placeholder);
      const body=document.createElement('div');body.className='hdp-ride-card__body';
      const heading=document.createElement('h3');heading.textContent=row.title;
      const price=document.createElement('p');price.className='hdp-ride-card__price';price.textContent='Loading price…';
      const action=document.createElement('span');action.className='hdp-ride-card__action';action.textContent='View product →';
      body.append(heading,price,action);link.append(media,body);li.append(link);this.results.append(li);
      return {li,media,price,heading,row,root};
    }
    async loadCard(card) {
      try {
        const response=await fetch(card.root+'products/'+encodeURIComponent(card.row.handle)+'.js');
        if(!response.ok)throw Error('Product unavailable');
        const product=await response.json();if(!card.li.isConnected)return;
        card.heading.textContent=product.title||card.row.title;
        card.media.replaceChildren();
        if(product.featured_image) {
          const image=document.createElement('img');
          const url=new URL(product.featured_image,location.origin);
          if(url.protocol!=='https:')throw Error('Invalid image');
          url.searchParams.set('width','640');image.src=url.href;image.alt=product.title||card.row.title;
          image.loading='lazy';image.decoding='async';image.width=640;image.height=640;
          image.addEventListener('error',()=>{card.media.textContent='Product photo unavailable';},{once:true});
          card.media.append(image);
        } else {card.media.textContent='Product photo unavailable';}
        sharedCurrency ||= fetch(card.root+'cart.js').then(r=>{if(!r.ok)throw Error('Currency unavailable');return r.json();}).then(c=>c.currency);
        const currency=await sharedCurrency;
        if(typeof currency!=='string'||!/^[A-Z]{3}$/.test(currency))throw Error('Currency unavailable');
        if(!card.li.isConnected)return;
        const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency});
        if(!Number.isFinite(product.price_min)||!Number.isFinite(product.price_max))throw Error('Price unavailable');
        card.price.textContent=(product.price_min!==product.price_max?'From ':'')+money.format(product.price_min/100);
        if(product.available===false){const unavailable=document.createElement('span');unavailable.className='hdp-ride-card__availability';unavailable.textContent='Currently unavailable';card.price.after(unavailable);}
      } catch (_) {
        if(!card.li.isConnected)return;
        if(card.media.textContent.includes('Loading'))card.media.textContent='View product photo';
        card.price.textContent='View current price';
      }
    }
    collapseTables() {
      if(!this.dataset.product) return;
      for(const table of document.querySelectorAll('.product__description table')) {
        const rows=[...table.rows];
        if(!rows.some(r=>r.cells.length>=3 && /^\s*\d{4}/.test(r.cells[0].textContent) && /Harley-Davidson/i.test(r.cells[1].textContent))) continue;
        const dataRows=rows.filter(r=>r.querySelector('td'));
        const columns=Math.max(...dataRows.map(r=>r.cells.length));
        for(let col=columns-1;col>=3;col--) {
          if(dataRows.every(r=>!r.cells[col]||/^[\s\-–—]*$/.test(r.cells[col].textContent))) {
            for(const row of rows)if(row.cells[col])row.deleteCell(col);
          }
        }
        if(!table.tHead&&dataRows.length) {
          const head=table.createTHead().insertRow();
          for(let col=0;col<dataRows[0].cells.length;col++) {
            const th=document.createElement('th');th.scope='col';th.textContent=['Year','Make','Model / submodel'][col]||'Additional details';head.append(th);
          }
        }
        if(table.closest('details')) continue;
        const details=document.createElement('details'),summary=document.createElement('summary');
        details.className='hdp-fitment-details'; summary.textContent='View detailed catalog fitment';
        table.before(details);details.append(summary,table);
      }
    }
  }
  customElements.define('hdp-ride-selector',RideSelector);
})();
